import { IProductFeature } from 'services/api/entities';
import {
  StyledCheckIcon,
  StyledCloseIcon,
  StyledList,
  StyledListItem,
  StyledTypography,
} from './styled';

type FeatureProps = {
  features: IProductFeature[];
};

const FeaturesList = ({ features }: FeatureProps) => (
  <StyledList>
    {features.map((feature) => (
      <StyledListItem key={feature.name.replace(' ', '-')}>
        {feature.isActive ? <StyledCheckIcon /> : <StyledCloseIcon />}
        <StyledTypography> {feature.name}</StyledTypography>
      </StyledListItem>
    ))}
  </StyledList>
);

export default FeaturesList;
